export const ways = {
  unique: 'Única',
  same_way: 'Mesma via',
  different_ways: 'Diferentes vias',
};

export function getName(value) {
  return ways[value];
}
